import { render, staticRenderFns } from "./AboutMobileDropDown.vue?vue&type=template&id=6570a036&scoped=true&"
import script from "./AboutMobileDropDown.vue?vue&type=script&lang=js&"
export * from "./AboutMobileDropDown.vue?vue&type=script&lang=js&"
import style0 from "./AboutMobileDropDown.vue?vue&type=style&index=0&id=6570a036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6570a036",
  null
  
)

export default component.exports